
export const INITIALIZE_TERMS = 'INITIALIZE_TERMS';
export const initializeTerms = (terms) => {
    return {
        type: INITIALIZE_TERMS,
        payload: terms
    };
};

export const INITIALIZE_CHANNEL_DATA = 'INITIALIZE_CHANNEL_DATA';
export const initializeChannel = (channel) => {
    return {
        type: INITIALIZE_CHANNEL_DATA,
        payload: channel
    };
};

export const INITIALIZE_LANGUAGES = 'INITIALIZE_LANGUAGES';
export const initializeLanguages = (languages) => {
    return {
        type: INITIALIZE_LANGUAGES,
        payload: languages
    };
};